import { getAuth } from 'firebase/auth';
import { useState } from 'react';

const FUNCTION_URL = 'https://us-central1-bkbo-45dc5.cloudfunctions.net/getUsers';

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const auth = getAuth();
      const token = await auth.currentUser.getIdToken();

      const res = await fetch(FUNCTION_URL, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!res.ok) throw new Error('Erreur lors de la récupération');
      const data = await res.json();
      setUsers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const filtered = users.filter(u =>
    u.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ padding: '24px' }}>
      <h2>Utilisateurs ({users.length})</h2>

      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
        <button onClick={fetchUsers} disabled={loading}>
          {loading ? 'Chargement...' : 'Récupérer les utilisateurs'}
        </button>

        {users.length > 0 && (
          <input
            type="text"
            placeholder="Rechercher par email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        )}
      </div>

      {error && <p style={{ color: 'red' }}>❌ {error}</p>}

      {filtered.length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ background: '#f3f4f6' }}>
            <tr>
              <th style={th}>Email</th>
              <th style={th}>UID</th>
              <th style={th}>Création</th>
              <th style={th}>Dernière connexion</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((user, i) => (
              <tr key={user.uid} style={{ background: i % 2 === 0 ? '#fff' : '#f9fafb' }}>
                <td style={td}>{user.email}</td>
                <td style={{ ...td, fontSize: '11px', color: '#888' }}>{user.uid}</td>
                <td style={td}>{new Date(user.creationTime).toLocaleDateString('fr-FR')}</td>
                <td style={td}>{new Date(user.lastSignInTime).toLocaleDateString('fr-FR')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const th = { padding: '10px 14px', textAlign: 'left', fontWeight: '600', borderBottom: '2px solid #e5e7eb' };
const td = { padding: '10px 14px', borderBottom: '1px solid #e5e7eb' };